//errorpage.js
import { useEffect } from 'react';
import { Outlet, Link, useLocation, Form, useRouteError } from 'react-router-dom';

import {wpUser,production,baseUrl} from '../../../k';

export default function SiteError() {
  const location = useLocation();
  const error = useRouteError();
  console.error({ error });
  useEffect(() => {
    let y = window.localStorage.getItem('baUid');
    console.log({ y });
    if (y == null) {
      window.location.href = `${wpUser}/account/${window['login']}`; 
    } else {
      //window.location.href = `${wpUser}/dashboard`;
      window.location.href = `${wpUser}/`;
    }
  }, [location]);
  //console.log(error)
  return (
    <div>
      {/*
      <p>An Error just occured</p>
       <div>
      An error just occured <i>{error.statusText || error.message}</i>
    </div>*/}
    </div>
  );
}
